import Utils from '../utils.js';

document.addEventListener('sebDocumentReady', function() {

	const allStates = {
		ac:'acre',
		al:'alagoas',
		ap:'amapa',
		am:'amazonas',
		ba:'bahia',
		ce:'ceara',
		es:'espirito santo',
		go:'goias',
		ma:'maranhao',
		mt:'mato grosso',
		ms:'mato grosso do sul',
		mg:'minas gerais',
		pa:'para',
		pb:'paraiba',
		pr:'parana',
		pe:'pernambuco',
		pi:'piaui',
		rj:'rio de janeiro',
		rn:'rio grande do norte',
		rs:'rio grande do sul',
		ro:'rondônia',
		rr:'roraima',
		sc:'santa catarina',
		sp:'sao paulo',
		se:'sergipe',
		to:'tocantins',
		df:'distrito federal',
	};

  const cepRange = {
		spCapital: { start: '01000-000', end: '05999-999' },
		spCapital2: { start: '08000-000', end: '08499-999' },
		spOsasco: { start: '06000-000', end: '06299-999' },
		spCarapicuiba: { start: '06300-000', end: '06399-999' },
		spBarueri: { start: '06400-000', end: '06499-999' },
		spSantanaParnaiba: { start: '06500-000', end: '06599-999' },
		spItapevi: { start: '06650-000', end: '06699-999' },
		spCotia: { start: '06700-000', end: '06739-999' },
		spTaboaoSerra: { start: '06750-000', end: '06799-999' },
		spGuarulhos: { start: '07000-000', end: '07399-999' },
		spSantoAndre: { start: '09000-000', end: '09299-999' },
		spMaua: { start: '09300-000', end: '09399-999' },
		spSaoBernardo: { start: '09600-000', end: '09899-999' },
		spDiadema: { start: '09900-000', end: '09999-999' },
		spLitoral: { start: '11000-000', end: '11999-999' },
		spInterior: { start: '12000-000', end: '19999-999' },
		rjCapital: { start: '20000-000', end: '23799-999' },
		rjMetro: { start: '20000-000', end: '26600-999' },
		rjInterior: { start: '26601-000', end: '28999-999' },
		esVitoria: { start: '29000-000', end: '29099-999' },
		esInterior: { start: '29100-000', end: '29999-999' },
		mgBeloHorizonte: { start: '30000-000', end: '31999-999' },
		mgMetro: { start: '30000-000', end: '34999-999' },
		mgInterior: { start: '35000-000', end: '39999-999' },
		baSalvador: { start: '40000-000', end: '41999-999' },
		baMetro: { start: '40000-000', end: '44470-999' },
		baInterior: { start: '44471-000', end: '48999-999' },
		seAracaju: { start: '49000-000', end: '49099-999' },
		seInterior: { start: '49100-000', end: '49999-999' },
		peRecife: { start: '50000-000', end: '52999-999' },
		peMetro: { start: '50000-000', end: '54999-999' },
		peInterior: { start: '55000-000', end: '56999-999' },
		alMaceio: { start: '57000-000', end: '57099-999' },
		alInterior: { start: '57100-000', end: '57999-999' },
		pbJoaoPessoa: { start: '58000-000', end: '58099-999' },
		pbInterior: { start: '58100-000', end: '58999-999' },
		rnNatal: { start: '59000-000', end: '59099-999' },
		rnInterior: { start: '59100-000', end: '59999-999' },
		ceFortaleza: { start: '60000-000', end: '60999-999' },
		ceMetro: { start: '60000-000', end: '61900-999' },
		ceInterior: { start: '61901-000', end: '63999-999' },
		piTeresina: { start: '64000-000', end: '64099-999' },
		piInterior: { start: '64100-000', end: '64999-999' },
		maSaoLuiz: { start: '65000-000', end: '65099-999' },
		maInterior: { start: '65100-000', end: '65999-999' },
		paBelem: { start: '66000-000', end: '66999-999' },
		paMetro: { start: '66000-000', end: '67999-999' },
		paInterior: { start: '68000-000', end: '68899-999' },
		apMacapa: { start: '68900-000', end: '68914-999' },
		apInterior: { start: '68915-000', end: '68999-999' },
		amManaus: { start: '69000-000', end: '69099-999' },
		amInterior: { start: '69100-000', end: '69299-999' },
		rrBoaVista: { start: '69300-000', end: '69339-999' },
		rrInterior: { start: '69340-000', end: '69389-999' },
		acRioBranco: { start: '69900-000', end: '69920-999' },
		acInterior: { start: '69921-000', end: '69999-999' },
		dfBrasilia: { start: '70000-000', end: '70999-999' },
		dfCidadesSatelite: { start: '71000-000', end: '73699-999' },
		goGoiania1: { start: '72800-000', end: '73999-999' },
		goGoiania2: { start: '74000-000', end: '74894-999' },
		goInterior: { start: '74895-000', end: '76799-999' },
		toPalmas: { start: '77000-000', end: '77270-999' },
		toInterior: { start: '77300-000', end: '77995-999' },
		mtCuiaba: { start: '78000-000', end: '78109-999' },
		mtInterior: { start: '78110-000', end: '78899-999' },
		roPortoVelho: { start: '78900-000', end: '78930-999' },
		msInterior1: { start: '78931-000', end: '78999-999' },
		msCampoGrande: { start: '79000-000', end: '79129-999' },
		msInterior2: { start: '79130-000', end: '79999-999' },
		prCuritiba: { start: '80000-000', end: '82999-999' },
		prMetro: { start: '80000-000', end: '83800-999' },
		prInterior: { start: '83801-000', end: '87999-999' },
		scFlorianopolis: { start: '88000-000', end: '88099-999' },
		scMetro: { start: '88100-000', end: '88469-999' },
		scInterior: { start: '88470-000', end: '89999-999' },
		rsPortoAlegre: { start: '90000-000', end: '91999-999' },
		rsMetro: { start: '90000-000', end: '94900-999' },
		rsInterior: { start: '94901-000', end: '99999-999' },
  };

	const resultsUnits = jQuery('.results-units');
	resultsUnits.each(function(index) {

		const current = jQuery(this);
		const lang = jQuery('html')[0].lang;
		const iconAddress = current.find('.icon-hidden.location').html();
		const iconPhone = current.find('.icon-hidden.phone').html();
		const iconGlobe = current.find('.icon-hidden.globe').data('url');
		const iconArrowSVG = current.find('.icon-hidden.arrow').html();
		const paginationBlock = current.find('.pagination-block');
		const grid = current.find('.grid');

		let allUnits = [];
		let searchForUnits = Utils.getURLParam('q');
		searchForUnits = searchForUnits || '';
		let query = Utils.removeAcentos(searchForUnits.toLowerCase().replace('-', ''));
		let unitsToRender = [];

		function onlyDigits(s) {
			return (s || '').toString().replace(/[^\d]/g, '');
		}
		
		function cepToNumber(cep) {
			return parseInt(onlyDigits(cep), 10);
		}

		function makePrefix3Matcher(rawQuery) {
			const q = onlyDigits(rawQuery);
			if (q.length !== 8) return null;
			const p3 = q.slice(0, 3);
			return (cep) => onlyDigits(cep).startsWith(p3);
		}

		function isInRange(cep, start, end) {
			const n = cepToNumber(cep);
			return n >= cepToNumber(start) && n <= cepToNumber(end);	
		}
		
		function getStateFromCepRangeKey(key) {
			if (!key) return null;
			const match = key.match(/^([a-z]{2})/i);
			return match ? match[1].toLowerCase() : null;
		}

		function getStateByCep(cep) {
			const rangeKey = findCepRange(cep);
			return getStateFromCepRangeKey(rangeKey);
		}

		function findCepRange(cep) {
			const n = cepToNumber(cep);
			for (const [key, range] of Object.entries(cepRange)) {
				if (isInRange(n, range.start, range.end)) return key;
			}
			return null;
		}

		function findClosestUnitByCep(inputCep, units) {
			const targetCepNum = cepToNumber(inputCep);
			const cepRangeKey = findCepRange(inputCep);
			const cepState = getStateFromCepRangeKey(cepRangeKey);
			if (!cepRangeKey || !cepState) return [];

			const currentRange = cepRange[cepRangeKey];
			if (!currentRange) return [];

			const rangeStart = cepToNumber(currentRange.start);
			const rangeEnd = cepToNumber(currentRange.end);

			const unitsInSameRegion = units.filter(u => {
				if (!u.cep) return false;
				const unitCepNum = cepToNumber(u.cep);
				const unitState = Utils.removeAcentos((u.province || '').toLowerCase());
				return (
					unitState.startsWith(cepState) &&
					unitCepNum >= rangeStart &&
					unitCepNum <= rangeEnd
				);
			});

			const sortedByDistance = unitsInSameRegion
				.map(u => ({
					...u,
					distance: Math.abs(cepToNumber(u.cep) - targetCepNum)
				}))
				.sort((a, b) => a.distance - b.distance);

			return sortedByDistance.slice(0, 3);
		}

		function createPagination(isFirstRender = false) {

			paginationBlock.removeClass('not-found');
			paginationBlock.removeClass('hide-pagination');
			unitsToRender = [];

			const prefix3Matcher = makePrefix3Matcher(searchForUnits);
			const qRaw = searchForUnits || '';
			const qDigits = onlyDigits(qRaw);
			const cepState = getStateByCep(qDigits);
			const useP3 = (qDigits.length === 8) || (qDigits.length === 3);
			const p3 = useP3 ? qDigits.slice(0, 3) : null;

			for(let i = 0; i < allUnits.length; i++) {
				let currentUnit = allUnits[i];
				let name = Utils.removeAcentos((currentUnit.name || '').toLowerCase());
				let cep = (currentUnit.cep || '').replace('-', '');
				let cepNoMask = onlyDigits(currentUnit.cep);
				let extraCep = currentUnit.extra_cep ? currentUnit.extra_cep.replace(/[\s-]/g,'').split(',').filter(Boolean) : [];
				let relatedSchools = Array.isArray(currentUnit.related_schools) && currentUnit.related_schools.length !== 0
				? currentUnit.related_schools.map(s => onlyDigits(s))
				: [];
				let city = Utils.removeAcentos((currentUnit.city || '').toLowerCase());
				let address = currentUnit.logradouro ? Utils.removeAcentos(currentUnit.logradouro.toLowerCase()) : '';
				let state = Utils.removeAcentos((currentUnit.province || '').toLowerCase());
				let fullState = Utils.removeAcentos(allStates[state] ? allStates[state] : '');

				if (!currentUnit.stringSegments) {
					currentUnit.stringSegments = Utils.removeAcentos(currentUnit.segments.join(', ').toLowerCase());
				}
				let segments = currentUnit.stringSegments;

				const byCepExact = (qDigits.length === 8) && (
					cepNoMask === qDigits ||
					extraCep.includes(qDigits) ||
					relatedSchools.includes(qDigits)
				);

				const byPrefix3 = useP3 ? (
					cepNoMask.startsWith(p3) ||
					extraCep.some(c => c.startsWith(p3)) ||
					relatedSchools.some(c => c.startsWith(p3))
				) : false;

				let byText =
				city.includes(query) ||
				address.includes(query) ||
				state.includes(query) ||
				segments.includes(query) ||
				name.includes(query) ||
				fullState.includes(query);

				if (!useP3) {
				byText = byText ||
						cep.includes(query) ||
						extraCep.includes(query) ||
						relatedSchools.includes(query);
				}

				if (query.replace('-', '') === cep) {
					unitsToRender.push(currentUnit);
					refreshPagination(isFirstRender);
					continue;
				}

				if (byCepExact || byPrefix3 || byText) {
					unitsToRender.push(currentUnit);
				}
			}
			
			if (unitsToRender.length === 0 && qDigits.length === 8) {
				const closestUnits = findClosestUnitByCep(qDigits, allUnits);
				if (closestUnits) {
					for (let unit of closestUnits) {
						const unitState = Utils.removeAcentos((unit.province || '').toLowerCase());
						if (cepState && !unitState.startsWith(cepState)) continue;
						console.log(`adicionou: ${unit.cep}`);
						unitsToRender.push(unit);
					}
				}
			}

			refreshPagination(isFirstRender);
		}

		const postsPerPage = function() {

			return jQuery(document).width() > 940 ? 12 : 6;
		}

		function refreshPagination(isFirstRender) {

			if(!isFirstRender) {
				paginationBlock.pagination('destroy');
			}
			
			paginationBlock.pagination({
			    dataSource: unitsToRender,
			    pageSize: postsPerPage(),
			    callback: function(data) {
			        let html = renderUnits(data);
			        grid.html(html);
			    },
			    prevText: iconArrowSVG,
			    nextText: iconArrowSVG,
			});

			if(unitsToRender.length == 0) {

				paginationBlock.addClass('not-found');
			
			} else if(unitsToRender.length <= postsPerPage()) {

				paginationBlock.addClass('hide-pagination');
			}
		}

		function renderUnits(units) {

			let elementsHTML = '';
			for(let i = 0; i < units.length; i++) {

				let unit = units[i];
				elementsHTML += '<div class="item"><img alt="" width="" height="" src="';
				elementsHTML += unit.get_image_url + '" /><div class="body"><div>';
				elementsHTML += '<p class="location">' + unit.city + ' - ' + unit.province + '</p>';	

				if(unit.secondary_link) {
					elementsHTML += '<a href="' + unit.secondary_link + '" class="title"';

					if(unit.secondary_link_target) {
						elementsHTML += ' target="_blank"';
					}
					elementsHTML += '>' + unit.name + '</a><div>';

				} else {
					elementsHTML += '<h4 class="title">'+ unit.name + '</h4><div>';
				}

				if(unit.logradouro) {

					elementsHTML += '<a';
					if(unit.address_url) {
						elementsHTML += ' href="' + unit.address_url + '" class="item-link has-link" target="_blank">';
					} else {
						elementsHTML += ' class="item-link">';
					}
					elementsHTML += iconAddress + unit.logradouro + '</a>';					
				}

				if(unit.phone) {
					elementsHTML += '<a href="tel:0' + unit.phone + '" class="item-link has-link" target="_blank">';
					elementsHTML += iconPhone + Utils.formatPhone(unit.phone) + '</a>';					
				}

				elementsHTML += '</div>';

				const description = unit.segments.join(', ');
				elementsHTML += '<p class="description">' + description + '</p>';

				elementsHTML += '</div>';

				if(unit.primary_link || unit.secondary_link) {

					elementsHTML += '<div class="columns"><div class="buttons">';
					if(unit.primary_link) {

						elementsHTML += '<a href="';
						elementsHTML += unit.primary_link;
						elementsHTML += '" class="btn btn-primary"' + (unit.primary_link_target ? ' target="_blank">' : ">");
						elementsHTML += '<span>' + (lang == 'pt' ? 'Agende uma visita' : '') + (lang == 'es' ? 'Programar una visita' : '') + (lang == 'en' ? 'Schedule a visit' : '') + '</span></a>';					
					}
					if(unit.secondary_link) {

						elementsHTML += '<a href="';
						elementsHTML += unit.secondary_link;
						elementsHTML += '" class="btn btn-secondary bg-light"' + (unit.secondary_link_target ? ' target="_blank">' : ">");
						elementsHTML += '<span>' + (lang == 'pt' ? 'Conheça a unidade' : '') + (lang == 'es' ? 'Conocer la unidad' : '') + (lang == 'en' ? 'Know the unit' : '') + '</span></a>';					
					}
					elementsHTML += '</div>';

					if(unit.address_url) {

						elementsHTML += '<a href="' + unit.address_url + '" class="link-globe" target="_blank">';
						elementsHTML += '<img src="' + iconGlobe + '" width="39" height="39" alt="" />';
						elementsHTML += '</a>';

					} else {	
						elementsHTML += '<img style="visibility: hidden;" src="' + iconGlobe + '" width="39" height="39" alt="" />';
					}
	
					elementsHTML += '</div>';
				}

				elementsHTML += '</div></div>';
			}

			return elementsHTML;
		}


		let viaCepResponse = '';
		let viaCepOk = true;
		let cepSearch = query.replace('-', '');
		let isCep = (cepSearch.length === 8 && (/^\d+$/).test(cepSearch)) ? true : false;
		
		if (isCep) {
			viaCepOk = false;

			setTimeout(() => {
				if (!viaCepOk) {
					viaCepOk = true;
					if (unitsOK) showResults();
				}
			}, 4000);

			fetch(`https://viacep.com.br/ws/${cepSearch}/json/`, { method: 'GET' })
				.then((response) => {
				if (!response.ok) throw new Error(`ViaCEP HTTP ${response.status}`);
					return response.json();
				})
				.then((data) => {
					viaCepResponse = data && data.localidade
						? Utils.removeAcentos(data.localidade.toLowerCase())
						: '';
					if (unitsOK) showResults();
				})
				.catch((err) => {
					viaCepResponse = '';
					if (unitsOK) showResults();
				})
				.finally(() => {
					viaCepOk = true;
				});
			}

		let unitsOK = false;
		fetch('/api/units', { method: 'GET' })
		.then((response) => {
			if (!response.ok) throw new Error(`/api/units HTTP ${response.status}`);
			return response.json();
		})
		.then((data) => {
			allUnits = data;
			if (viaCepOk) showResults();
			unitsOK = true;
		})
		.catch((err) => {
			allUnits = [];
			unitsOK = true;
			if (viaCepOk) showResults();
		});

		function showResults() {

			paginationBlock.removeClass('is-loading')
			createPagination(true);
			window.addEventListener('resize', function(event) {
			    createPagination();
			});
		}
	});
});